import React from 'react'
import * as R from 'ramda'

import {
  getTraitTranslation,
  getTraitsTranslations,
} from 'components/modals/TestsReportModal/tabs/helpers'
import { TRAITS } from 'components/common/ScoreCard/ScoreCard'

export const useTrait = ({
  factor,
  language,
  scores,
  response,
  isCandidate,
}) => {
  const score = R.prop(factor, scores)

  const { label, abstract = [], description = [] } = getTraitTranslation(
    factor,
    score,
    language,
    isCandidate,
  )

  const traits = TRAITS[factor]
  const traitsCount = R.length(traits)
  const attributes = getTraitsTranslations(traits, response, language)

  const [selectedAttributes, setSelectedAttributes] = React.useState(
    attributes.reduce((acc, attribute) => {
      return { ...acc, [attribute.id]: false }
    }, {}),
  )

  const allScores = response.map(({ id, scores }) => ({
    id: id,
    score: Math.round(scores[factor] * 100),
  }))

  const allExpanded = attributes.every(
    attribute => selectedAttributes[attribute.id],
  )

  const selectAllAttributes = () =>
    setSelectedAttributes(
      attributes.reduce(
        (acc, attribute) => ({ ...acc, [attribute.id]: !allExpanded }),
        {},
      ),
    )

  const selectAttribute = id => isOpen =>
    setSelectedAttributes({
      ...selectedAttributes,
      [id]: isOpen,
    })

  return {
    state: {
      abstract,
      attributes,
      selectedAttributes,
      selectAllAttributes,
      selectAttribute,
      description,
      allExpanded,
      label,
      score,
      traits,
      traitsCount,
      allScores,
    },
  }
}
